export default __webpack_public_path__ + "static/media/Banner-Promo-personaje.d94e551d.png";